<template>
    <div>
        <v-row>
            <v-col cols="6">
                <h1 class="headline font-weight-light mb-3">
                    Change Request Form
                </h1>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" class="text-right">
                <v-btn small rounded color="primary" @click="open_form()">
                    <v-icon small class="mr-1">mdi-plus</v-icon> Create Request
                    Form
                </v-btn>
            </v-col>
        </v-row>

        <v-card>
            <v-row class="mt-3">
                <v-col cols="10" sm="5" md="3" class="ml-1">
                    <v-text-field
                        v-model="search.search"
                        label="Search.."
                        dense
                        outlined
                    ></v-text-field>
                </v-col>
                <v-col cols="10" sm="5" md="3">
                    <v-menu
                        v-model="modal3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                v-model="dateRangeText"
                                label="Date range"
                                readonly
                                v-on="on"
                                dense
                                outlined
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="search.date"
                            range
                            @change="get_date()"
                        ></v-date-picker>
                    </v-menu>
                </v-col>
                <v-col cols="2">
                    <v-btn
                        class="mt-1"
                        x-small
                        fab
                        :color="
                            chk_data_main == false ? 'green accent-2' : 'amber'
                        "
                        @click="get_data()"
                        :disabled="
                            search.search == '' && search.date.length == 0
                        "
                        ><v-icon>mdi-arrow-right</v-icon></v-btn
                    >
                    <v-btn
                        x-small
                        fab
                        class="ml-1 mt-1"
                        v-if="search.search != '' || search.date != ''"
                        @click="reset()"
                    >
                        <v-icon>mdi-rotate-left</v-icon></v-btn
                    >
                </v-col>
            </v-row>
            <v-row class="mar-t-20">
                <v-col cols="12">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center" width="5%">#</th>
                                    <th class="text-center" width="20%">
                                        Change
                                    </th>
                                    <th class="text-center" width="55%">
                                        Title
                                    </th>
                                    <th class="text-center" width="20%">
                                        Status
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(row, index) in data_main"
                                    :key="index"
                                >
                                    <td class="text-center">
                                        {{ index + 1 }}.
                                    </td>
                                    <td class="text-center">
                                        <v-btn
                                            :color="
                                                row.status === 'Closed'
                                                    ? 'green accent-2'
                                                    : row.status ===
                                                      'Not Approved'
                                                    ? 'red accent-3'
                                                    : ''
                                            "
                                            rounded
                                            small
                                            @click="
                                                get_data2(
                                                    row.change_id,
                                                    row.status
                                                )
                                            "
                                            >{{ row.change_id }}</v-btn
                                        >
                                    </td>
                                    <td>{{ row.title }}</td>
                                    <td class="text-center">
                                        {{ row.status }}
                                    </td>
                                </tr>
                                <br />
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </v-card>

        <div>
            <v-row justify="center">
                <v-dialog
                    v-model="dialog"
                    fullscreen
                    hide-overlay
                    transition="dialog-bottom-transition"
                >
                    <v-card tile>
                        <v-toolbar flat dark color="primary">
                            <v-btn icon dark @click="close_form()">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <!-- <v-toolbar-title></v-toolbar-title>
                            <v-spacer></v-spacer> -->
                        </v-toolbar>
                        <v-card-text>
                            <v-list three-line subheader>
                                <v-list-item>
                                    <v-list-item-content>
                                        <v-row>
                                            <v-col cols="12">
                                                <v-card
                                                    :color="
                                                        show == false
                                                            ? 'grey lighten-2'
                                                            : 'grey lighten-4'
                                                    "
                                                >
                                                    <v-card-title>
                                                        Change Request Form
                                                        <v-spacer></v-spacer>

                                                        <v-btn
                                                            icon
                                                            @click="
                                                                show = !show
                                                            "
                                                        >
                                                            <v-icon>{{
                                                                show
                                                                    ? "mdi-chevron-up"
                                                                    : "mdi-chevron-down"
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </v-card-title>

                                                    <v-expand-transition>
                                                        <div v-show="show">
                                                            <v-form
                                                                method="post"
                                                                id="nativeForm"
                                                                v-model="valid"
                                                            >
                                                                <v-row>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >หัวข้อเรื่อง</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-text-field
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            v-model="
                                                                                form_save.title
                                                                            "
                                                                            :rules="
                                                                                titleR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุหัวข้อเรื่อง"
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >สาเหตุของการเปลี่ยนแปลง
                                                                        </span>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-textarea
                                                                            rows="3"
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            v-model="
                                                                                form_save.cause
                                                                            "
                                                                            :rules="
                                                                                causeR
                                                                            "
                                                                            outlined
                                                                            label="ระบุสาเหตุของการเปลี่ยนแปลง.."
                                                                            required
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >สิ่งที่ต้องดำเนินการ</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-textarea
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            rows="3"
                                                                            v-model="
                                                                                form_save.solution
                                                                            "
                                                                            :rules="
                                                                                solutionR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุสิ่งที่ต้องดำเนินการ"
                                                                            outlined
                                                                            required
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >ผลกระทบของการเปลี่ยนแปลง</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-textarea
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            rows="3"
                                                                            v-model="
                                                                                form_save.effect
                                                                            "
                                                                            :rules="
                                                                                effectR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุผลกระทบของการเปลี่ยนแปลง"
                                                                            outlined
                                                                            required
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >ระยะเวลาดำเนินการโดยประมาณ
                                                                            (วัน)</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-text-field
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            v-model="
                                                                                form_save.manday
                                                                            "
                                                                            :rules="
                                                                                mandayR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุระยะเวลาดำเนินการโดยประมาณ (วัน))"
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >งบประมาณ
                                                                            (โดยประมาณ)</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-text-field
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            v-model="
                                                                                form_save.budget
                                                                            "
                                                                            :rules="
                                                                                budgetR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุงบประมาณ (โดยประมาณ)"
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >ระดับความเสี่ยง</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-radio-group
                                                                            class="mar-t-05"
                                                                            :disabled="
                                                                                status_main !=
                                                                                    ''
                                                                            "
                                                                            v-model="
                                                                                form_save.risk_level
                                                                            "
                                                                            row
                                                                            :rules="
                                                                                risk_levelR
                                                                            "
                                                                        >
                                                                            <v-radio
                                                                                label="Low"
                                                                                value="Low"
                                                                            ></v-radio>
                                                                            <v-radio
                                                                                label="Medium"
                                                                                value="Medium"
                                                                            ></v-radio>
                                                                            <v-radio
                                                                                label="High"
                                                                                value="High"
                                                                            ></v-radio>
                                                                        </v-radio-group>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main ==
                                                                            ''
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="11"
                                                                        class="text-right"
                                                                    >
                                                                        <v-btn
                                                                            rounded
                                                                            small
                                                                            color="green"
                                                                            :disabled="
                                                                                !valid
                                                                            "
                                                                            @click="
                                                                                save_form()
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="ml-3 mr-3 white--text"
                                                                                >Save
                                                                                Change
                                                                                Request
                                                                                Form</span
                                                                            >
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main ==
                                                                            'Request' &&
                                                                            emp_id ==
                                                                                'P03-009'
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="11"
                                                                        class="text-right"
                                                                    >
                                                                        <v-btn
                                                                            class="mr-1"
                                                                            small
                                                                            color="success"
                                                                            dark
                                                                            @click="
                                                                                save_approve(
                                                                                    'Approved'
                                                                                )
                                                                            "
                                                                        >
                                                                            Approved
                                                                        </v-btn>

                                                                        <v-menu
                                                                            v-model="
                                                                                menu
                                                                            "
                                                                            :close-on-content-click="
                                                                                false
                                                                            "
                                                                            :nudge-width="
                                                                                200
                                                                            "
                                                                            offset-x
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    on,
                                                                                    attrs,
                                                                                }"
                                                                            >
                                                                                <v-btn
                                                                                    small
                                                                                    color="red"
                                                                                    dark
                                                                                    v-bind="
                                                                                        attrs
                                                                                    "
                                                                                    v-on="
                                                                                        on
                                                                                    "
                                                                                >
                                                                                    Not
                                                                                    Approved
                                                                                </v-btn>
                                                                            </template>

                                                                            <v-card>
                                                                                <v-list>
                                                                                    <v-list-item>
                                                                                        <v-text-field
                                                                                            small
                                                                                            label="เหตุผลที่ไม่อนุมัติ..."
                                                                                            v-model="
                                                                                                form_save.remark
                                                                                            "
                                                                                        ></v-text-field>
                                                                                    </v-list-item>
                                                                                </v-list>

                                                                                <v-card-actions>
                                                                                    <v-btn
                                                                                        small
                                                                                        text
                                                                                        @click="
                                                                                            close_approve()
                                                                                        "
                                                                                        >Cancel</v-btn
                                                                                    >
                                                                                    <v-spacer></v-spacer>
                                                                                    <v-btn
                                                                                        small
                                                                                        color="success"
                                                                                        @click="
                                                                                            save_approve(
                                                                                                'Not Approved'
                                                                                            )
                                                                                        "
                                                                                        >Save</v-btn
                                                                                    >
                                                                                </v-card-actions>
                                                                            </v-card>
                                                                        </v-menu>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main !=
                                                                            'Request' &&
                                                                            status_main !=
                                                                                ''
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >สถานะการอนุมัติ</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <span
                                                                            v-if="
                                                                                form_save.approved_remark
                                                                            "
                                                                            class="font-weight-bold"
                                                                            >ไม่อนุมัติ
                                                                            :
                                                                            {{
                                                                                form_save.approved_remark
                                                                            }}</span
                                                                        >
                                                                        <span
                                                                            v-else
                                                                            class="font-weight-bold"
                                                                            >อนุมัติ</span
                                                                        >

                                                                        {{
                                                                            form_save.approved_name
                                                                        }}
                                                                        (
                                                                        {{
                                                                            form_save.approved_date
                                                                        }}
                                                                        )
                                                                    </v-col>
                                                                </v-row>
                                                            </v-form>
                                                        </div>
                                                    </v-expand-transition>
                                                </v-card>
                                            </v-col>

                                            <v-col
                                                cols="12"
                                                v-if="
                                                    status_main != '' &&
                                                        status_main !=
                                                            'Request' &&
                                                        status_main !=
                                                            'Not Approved'
                                                "
                                            >
                                                <v-card
                                                    :color="
                                                        show2 == false
                                                            ? 'grey lighten-2'
                                                            : 'grey lighten-4'
                                                    "
                                                >
                                                    <v-card-title>
                                                        แนวทางการดำเนินการเปลี่ยนแปลง
                                                        <v-spacer></v-spacer>

                                                        <v-btn
                                                            icon
                                                            @click="
                                                                show2 = !show2
                                                            "
                                                        >
                                                            <v-icon>{{
                                                                show2
                                                                    ? "mdi-chevron-up"
                                                                    : "mdi-chevron-down"
                                                            }}</v-icon>
                                                        </v-btn>
                                                    </v-card-title>

                                                    <v-expand-transition>
                                                        <div v-show="show2">
                                                            <v-form
                                                                method="post"
                                                                id="nativeForm"
                                                                v-model="valid2"
                                                            >
                                                                <v-row>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >แผนการเปลี่ยนแปลง
                                                                        </span>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-textarea
                                                                            :disabled="
                                                                                status_main ==
                                                                                    'On Process' ||
                                                                                    status_main ==
                                                                                        'Closed'
                                                                            "
                                                                            v-model="
                                                                                form_save.change_plan
                                                                            "
                                                                            :rules="
                                                                                change_planR
                                                                            "
                                                                            outlined
                                                                            label="ระบุแผนการเปลี่ยนแปลง.."
                                                                            required
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >แผนกู้คืนระบบ</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-textarea
                                                                            outlined
                                                                            :disabled="
                                                                                status_main ==
                                                                                    'On Process' ||
                                                                                    status_main ==
                                                                                        'Closed'
                                                                            "
                                                                            v-model="
                                                                                form_save.recovery_plan
                                                                            "
                                                                            :rules="
                                                                                recovery_planR
                                                                            "
                                                                            label="ระบุแผนกู้คืนระบบ"
                                                                            required
                                                                        ></v-textarea>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >วันที่เริ่มดำเนินการเปลี่ยนแปลง</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="mar-t-20"
                                                                    >
                                                                        <v-dialog
                                                                            ref="dialog2"
                                                                            v-model="
                                                                                modal4
                                                                            "
                                                                            :return-value.sync="
                                                                                form_save.change_start
                                                                            "
                                                                            persistent
                                                                            width="290px"
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    on,
                                                                                }"
                                                                            >
                                                                                <v-text-field
                                                                                    :disabled="
                                                                                        status_main ==
                                                                                            'On Process' ||
                                                                                            status_main ==
                                                                                                'Closed'
                                                                                    "
                                                                                    v-model="
                                                                                        form_save.change_start
                                                                                    "
                                                                                    label="Date"
                                                                                    prepend-icon=""
                                                                                    readonly
                                                                                    v-on="
                                                                                        on
                                                                                    "
                                                                                    :rules="
                                                                                        change_startR
                                                                                    "
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                v-model="
                                                                                    form_save.change_start
                                                                                "
                                                                                scrollable
                                                                            >
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        modal4 = false
                                                                                    "
                                                                                    >Cancel</v-btn
                                                                                >
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        $refs.dialog2.save(
                                                                                            form_save.change_start
                                                                                        )
                                                                                    "
                                                                                    >OK</v-btn
                                                                                >
                                                                            </v-date-picker>
                                                                        </v-dialog>
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >วันที่คาดว่าจะดำเนินการเสร็จสิ้น</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="3"
                                                                        class="mar-t-20"
                                                                    >
                                                                        <v-dialog
                                                                            ref="dialog"
                                                                            v-model="
                                                                                modal
                                                                            "
                                                                            :return-value.sync="
                                                                                form_save.deadline
                                                                            "
                                                                            persistent
                                                                            width="290px"
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    on,
                                                                                }"
                                                                            >
                                                                                <v-text-field
                                                                                    :disabled="
                                                                                        status_main ==
                                                                                            'On Process' ||
                                                                                            status_main ==
                                                                                                'Closed'
                                                                                    "
                                                                                    v-model="
                                                                                        form_save.deadline
                                                                                    "
                                                                                    label="Date"
                                                                                    prepend-icon=""
                                                                                    readonly
                                                                                    v-on="
                                                                                        on
                                                                                    "
                                                                                    :rules="
                                                                                        deadlineR
                                                                                    "
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                v-model="
                                                                                    form_save.deadline
                                                                                "
                                                                                scrollable
                                                                            >
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        modal = false
                                                                                    "
                                                                                    >Cancel</v-btn
                                                                                >
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        $refs.dialog.save(
                                                                                            form_save.deadline
                                                                                        )
                                                                                    "
                                                                                    >OK</v-btn
                                                                                >
                                                                            </v-date-picker>
                                                                        </v-dialog>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main ==
                                                                            'On Process' ||
                                                                            status_main ==
                                                                                'Closed'
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >ผลการดำเนินการ</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-text-field
                                                                            :disabled="
                                                                                status_main ==
                                                                                    'Closed'
                                                                            "
                                                                            v-model="
                                                                                form_save.finished_result
                                                                            "
                                                                            :rules="
                                                                                finished_resultR
                                                                            "
                                                                            class="mar-t-20"
                                                                            label="ระบุผลการดำเนินการ"
                                                                        ></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main ==
                                                                            'On Process'
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="2"
                                                                        class="text-right"
                                                                    >
                                                                        <span
                                                                            class="fix-title"
                                                                            >วันที่ดำเนินการเสร็จสิ้น</span
                                                                        >
                                                                    </v-col>
                                                                    <v-col
                                                                        cols="12"
                                                                        md="9"
                                                                    >
                                                                        <v-dialog
                                                                            ref="dialog"
                                                                            v-model="
                                                                                modal2
                                                                            "
                                                                            :return-value.sync="
                                                                                form_save.finished_date
                                                                            "
                                                                            persistent
                                                                            width="290px"
                                                                        >
                                                                            <template
                                                                                v-slot:activator="{
                                                                                    on,
                                                                                }"
                                                                            >
                                                                                <v-text-field
                                                                                    :disabled="
                                                                                        status_main ==
                                                                                            'Closed'
                                                                                    "
                                                                                    v-model="
                                                                                        form_save.finished_date
                                                                                    "
                                                                                    label="Date"
                                                                                    prepend-icon=""
                                                                                    readonly
                                                                                    v-on="
                                                                                        on
                                                                                    "
                                                                                    :rules="
                                                                                        finished_dateR
                                                                                    "
                                                                                ></v-text-field>
                                                                            </template>
                                                                            <v-date-picker
                                                                                v-model="
                                                                                    form_save.finished_date
                                                                                "
                                                                                scrollable
                                                                            >
                                                                                <v-spacer></v-spacer>
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        modal2 = false
                                                                                    "
                                                                                    >Cancel</v-btn
                                                                                >
                                                                                <v-btn
                                                                                    text
                                                                                    color="primary"
                                                                                    @click="
                                                                                        $refs.dialog.save(
                                                                                            form_save.finished_date
                                                                                        )
                                                                                    "
                                                                                    >OK</v-btn
                                                                                >
                                                                            </v-date-picker>
                                                                        </v-dialog>
                                                                    </v-col>
                                                                </v-row>
                                                                <v-row
                                                                    v-if="
                                                                        status_main !=
                                                                            'Closed'
                                                                    "
                                                                >
                                                                    <v-col
                                                                        cols="12"
                                                                        md="11"
                                                                        class="text-right"
                                                                    >
                                                                        <v-btn
                                                                            rounded
                                                                            small
                                                                            color="green"
                                                                            :disabled="
                                                                                !valid2
                                                                            "
                                                                            @click="
                                                                                save_form()
                                                                            "
                                                                        >
                                                                            <span
                                                                                class="ml-3 mr-3 white--text"
                                                                                >Save
                                                                            </span>
                                                                        </v-btn>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-form>
                                                        </div>
                                                    </v-expand-transition>
                                                </v-card>
                                            </v-col>
                                        </v-row>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-row>
        </div>

        <div id="snackbar" class="d-print-none">
            <v-snackbar v-model="snackbar" color="success" right>
                {{ text }}
            </v-snackbar>
        </div>

        <back-to-top bottom="50px" right="50px">
            <v-btn small fab color="deep-purple lighten-2">
                <v-icon style="color:#FFF">mdi-chevron-up</v-icon>
            </v-btn>
        </back-to-top>
    </div>
</template>
<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

let url = `${process.env.VUE_APP_ROOT_API}/api/`
export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_emp()
    },
    computed: {
        ...mapState(["snackbar"]),
        dateRangeText() {
            this.search.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })

            return this.search.date.join(" ~ ")
        },
    },
    methods: {
        ...mapMutations(["mutatesnackbar"]),
        async get_emp() {
            if (this.role_name == "Management") {
                await axios
                    .get(url + "account-detail", {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    })
                    .then((response) => {
                        this.emp_id = response.data.emp_id
                        this.get_data()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.get_data()
            }
        },
        async get_data() {
            this.chk_data_main = true
            await axios
                .post(url + "change", this.search, this.tk)
                .then((response) => {
                    this.chk_data_main = false
                    this.data_main = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        async get_data2(id, st) {
            if (st == "" || st == "Request" || st == "Not Approved") {
                this.show = true
            } else if (st == "Closed") {
                this.show = false
                this.show2 = false
            } else {
                this.show = false
                this.show2 = true
            }
            this.status_main = st

            await axios
                .get(url + "change/" + id, this.tk)
                .then((response) => {
                    this.form_save = response.data
                    this.dialog = true
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        open_form() {
            this.show = true
            this.dialog = true
        },
        close_form() {
            this.status_main = ""
            this.form_save = {
                title: "",
                cause: "",
                solution: "",
                effect: "",
                manday: "",
                budget: "",
                risk_level: "",
                change_plan: "",
                recovery_plan: "",
                finished_result: "",
                deadline: "",
                change_start: "",
                finished_date: "",
                change_id: "",
                remark: "",
            }

            this.dialog = false
        },
        async save_form() {
            let urlx
            if (this.status_main == "") {
                urlx = "change/new-request"
            } else if (this.status_main == "Approved") {
                urlx = "change/save-update/" + this.form_save.change_id
            } else if (this.status_main == "On Process") {
                urlx = "change/closed/" + this.form_save.change_id
            }
            await axios
                .post(url + urlx, this.form_save, this.tk)
                .then((response) => {
                    this.mutatesnackbar()
                    this.close_form()
                    this.get_data()

                    if (this.snackbar === true) {
                        setTimeout(() => {
                            this.mutatesnackbar()
                        }, 3000)
                    }
                })
                .catch(function(error) {
                    console.log(error)
                })
        },
        reset() {
            this.search = {
                search: "",
                date: [],
            }
            // this.get_data()
        },
        get_date() {
            if (this.dateRangeText.length === 23) {
                this.modal3 = false
            }
        },
        save_approve(st) {
            this.$swal({
                title: "Are you sure ?",
                text: st,
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then((confirm) => {
                if (confirm) {
                    let send = {
                        approve_status: st,
                        remark: this.form_save.remark,
                    }
                    axios
                        .post(
                            url +
                                "change/save-approve/" +
                                this.form_save.change_id,
                            send,
                            this.tk
                        )
                        .then((response) => {
                            this.mutatesnackbar()
                            this.close_form()
                            this.get_data()
                            if (this.snackbar === true) {
                                setTimeout(() => {
                                    this.mutatesnackbar()
                                }, 3000)
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }
            })
        },
        close_approve() {
            this.menu = false
            this.form_save.remark = ""
        },
    },
    data() {
        return {
            tk: null,
            data_main: [],
            text: "Success, Your work has been saved",
            dialog: false,
            form_save: {
                title: "",
                cause: "",
                solution: "",
                effect: "",
                manday: "",
                budget: "",
                risk_level: "",
                change_plan: "",
                recovery_plan: "",
                finished_result: "",
                deadline: "",
                change_start: "",
                finished_date: "",
                change_id: "",
                remark: "",
            },

            valid: false,
            valid2: false,
            titleR: [(v) => !!v || "โปรดระบุ...หัวข้อเรื่อง"],
            causeR: [(v) => !!v || "โปรดระบุ...สาเหตุของการเปลี่ย`นแปลง"],
            solutionR: [(v) => !!v || "โปรดระบุ...สิ่งที่ต้องดำเนินการ"],
            effectR: [(v) => !!v || "โปรดระบุ...ผลกระทบของการเปลี่ยนแปลง"],
            mandayR: [
                (v) => !!v || "โปรดระบุ...ระยะเวลาการดำเนินงาน",
                (v) => /^\d+$/.test(v) || "Manday should be a number",
            ],
            budgetR: [
                (v) => !!v || "โปรดระบุ...งบประมาณ",
                (v) => /^\d+$/.test(v) || "Budget should be a number",
            ],
            risk_levelR: [
                (v) => !!v || "โปรดระบุ...ระดับความเสี่ยงของการเปลี่ยนแปลง",
            ],
            change_planR: [(v) => !!v || "โปรดระบุ...แผนการเปลี่ยนแปลง"],
            recovery_planR: [(v) => !!v || "โปรดระบุ...แผนการกู้คืนระบบ"],
            change_startR: [(v) => !!v || "โปรดระบุ...วันที่เริ่มดำเนินการ"],
            deadlineR: [(v) => !!v || "โปรดระบุ...วันที่คาดว่าดำเนินการเสร็จ"],
            finished_resultR: [(v) => !!v || "โปรดระบุ...ผลการดำเนินการ"],
            finished_dateR: [
                (v) => !!v || "โปรดระบุ...วันที่ดำเนินการเสร็จสิ้น",
            ],
            show: false,
            show2: false,
            modal: false,
            modal2: false,
            modal3: false,
            modal4: false,
            status_main: "",
            emp_id: "",
            role_name: localStorage.role_name,
            search: {
                search: "",
                date: [],
            },
            chk_data_main: false,
            menu: false,
        }
    },
}
</script>

<style scoped>
.fix-title {
    /* font-weight: bold; */
    font-size: 18px;
}
</style>
